import { render, staticRenderFns } from "./MethodologyTab.vue?vue&type=template&id=25accd6d&scoped=true&"
import script from "./MethodologyTab.vue?vue&type=script&lang=js&"
export * from "./MethodologyTab.vue?vue&type=script&lang=js&"
import style0 from "./MethodologyTab.vue?vue&type=style&index=0&id=25accd6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25accd6d",
  null
  
)

export default component.exports